import React, {useState, useEffect} from 'react'
import {
     Grid,
     TextField,  
     FormControl, 
     FormHelperText, 
     Button,
     Typography
} from '@mui/material'
import {styles} from './styles';
import { useStateValue } from "../../../../context/store";
import { useForm, } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const SearchLabel = (props) => {

    const classes = styles()
    const [{aplicationQuestionary, breadCrumb}, dispatch] = useStateValue();
    const [dataForm, setDataForm] = useState({
        label: '',
        keyword: '',
    })
    
    const schema = yup.object().shape({
        keyword: dataForm?.keyword ? yup
        .string()
        .notRequired()
        .nullable(true)
        .transform((value) =>
            encodeURIComponent(value)
        ) 
        .max(100, 'Ingrese máximo 100 caracteres') : null,
        from: yup
        .string()
        .notRequired()
        .nullable(true),
        until: yup
        .string()
        .notRequired()
        .nullable(true), 
      });
    
      
      const { register, handleSubmit, clearErrors, trigger, formState:{errors}, setValue, watch } = useForm({
        resolver: yupResolver(schema),
        mode: "all",
        reValidateMode: "onChange",
      });

      const handleClose = () => props.setMessage({...props.message, open: false})

      const onSubmit = (data) => {
          if(data.from === '' && data.keyword === ''  && data?.until === ''){
            return  props?.setMessage({
                message: 'Ingrese información en algúno de los campos',
                open: true,
                severity: 'error',
                handleClose: () => handleClose()
              })
          }
          if(watch('until') && watch('from') && (data.until < data?.from ) ){
            return  props?.setMessage({
                open : true,
                description: 'La fecha final no puede ser menor que la fecha inicial',
                handleClick : () => handleClose() ,
                oneButtons : true,
                textButtonSubmit: 'ACEPTAR',
                type : 'WARNING',
              })
          }
          if(
            data?.from !== '' ||
            data?.until !== '' ||
            data?.keyword !== '' 
        ){
            dispatch({
                type: "SET_FILTER_APLICATION",
                filter: {
                    createdAtStartDate: data?.from,
                    createdAtEndDate: data?.until,
                    questionnaireNameKeyword: data?.keyword,
                    page: 0,
                    size: 10
                  },
                  isFilter: true,
            })
        } else {
            dispatch({
                type: "SET_FILTER_APLICATION",
                filter: {
                    createdAtStartDate: null,
                    createdAtEndDate: null,
                    questionnaireNameKeyword: null,
                  },
                  isFilter: true,
            })
        }
      }

      useEffect(() => {
        clear()
      }, [props?.clearFielForm])


      const handleChange = (e) => {
        const {value, name} = e.target;
        setDataForm({...dataForm, [name]:value})
        if(name === 'keyword'){
            setValue(name, value)
            trigger(name)
        }
      }

    const clear = () => {
        setValue('from','')
        setValue('until', '')
        setValue('keyword', '')
        clearErrors('keyword')
        props.clearFilter()
    }

    useEffect(()=> {
        if(breadCrumb?.module === "DETAIL_APLICATION" && aplicationQuestionary?.isFilter){
            setValue('from',aplicationQuestionary?.filter?.createdAtStartDate)
            setValue('until', aplicationQuestionary?.filter?.createdAtEndDate)
            setValue('keyword', aplicationQuestionary?.filter?.questionnaireNameKeyword)
        }
     
    },[breadCrumb?.module === "DETAIL_APLICATION"])

      const validate = watch('from') || watch('keyword') ||  watch('until') 
      const disabledButton = errors['keyword'] || !validate

    return (
        <form onSubmit={handleSubmit(onSubmit)} >
            <Grid container spacing={2} style={{alignItems: 'flex-end', marginTop: '-4%'}}>
                <Grid item spacing={1} lg={4} style={{display:'flex ', flexDirection: 'column' }}>
                    <div >
                        <Typography style={{fontSize: 12, color:'#8E8E8E', textAlign: 'center', paddingBottom: 10 }}>Fecha de creación</Typography>
                        <div style={{display:'flex ', flexDirection: 'row' }}>
                            <Grid item xs={12} sm={12} md={12} lg={12} style={{display: 'flex', flexDirection:'row', marginRight: 5}}>
                                <FormControl fullWidth size="small">
                                <TextField 
                                    {...register('from')}
                                    size="small"
                                    type="date"
                                    label="Desde"
                                    className={classes.fieldDateTimeErrorSearch}
                                    minDate={new Date()}
                                    InputLabelProps={{
                                        shrink: true,
                                        notched: true
                                    }}
                                    error={!!errors.hasOwnProperty("from") && errors["from"].message }
                                />
                                <FormHelperText style={{color:'#d70909'}}>
                                    {!!errors.hasOwnProperty("from") &&
                                    errors["from"].message}
                                </FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12} style={{display: 'flex', marginLeft: 5}}>
                            <FormControl fullWidth size="small">
                                <TextField 
                                    {...register('until')}
                                    size="small"
                                    type="date"
                                    label="Hasta"
                                    className={classes.fieldDateTimeErrorSearch}
                                    minDate={new Date()}
                                    InputLabelProps={{
                                        shrink: true,
                                        notched: true
                                    }}
                                    error={!!errors.hasOwnProperty("until") && errors["until"].message }
                                />
                                <FormHelperText style={{color:'#d70909'}}>
                                    {!!errors.hasOwnProperty("until") &&
                                    errors["until"].message}
                                </FormHelperText>
                                </FormControl>
                            </Grid>
                        </div>
                </div>
               
                </Grid>
            
                <Grid item xs={12} sm={12} md={12} lg={4}>
                <FormControl variant='outlined' fullWidth size="small">
                    <TextField
                    {...register('keyword')}
                    className={classes.dropdownNameCuestionary}
                    fullWidth
                    onChange={handleChange}
                    size="small"
                    placeholder="Palabra clave"
                    // InputLabelProps={{
                    //     className: classes.labelProps
                    // }}
                    error={!!errors.hasOwnProperty("keyword") && errors["keyword"].message}
                    helperText={!!errors.hasOwnProperty("keyword") && errors["keyword"].message}
                  />
                </FormControl>
                <FormHelperText style={{color:'#d70909'}}>
                    {!!errors.hasOwnProperty("from") &&
                    errors["from"].message}
                </FormHelperText>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={3.8} style={{display: 'flex',  alignItems: 'center', marginLeft: '1%', marginBottom: '0.5%'}}>
                    <Button 
                        variant="contained" 
                        type="submit" 
                        disabled={disabledButton}
                        disableElevation 
                        style={{color: "#ffffff",background: disabledButton ? '#C0C0C0' : "#2F71CB" }}
                    >
                        BUSCAR
                    </Button>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <Button 
                        variant="contained"  
                        disableElevation 
                        onClick={clear}
                        style={{color: "#ffffff",background:  "#2F71CB", width: '65%'}}
                    >
                        LIMPIAR
                    </Button>

                </Grid>
            </Grid>
         </form>
    )
}

export default SearchLabel
